import "./native-information.css";

// Only explicit article navigation unlocks page scrolling. Editor libraries and
// popovers own their scroll; reaching their edges cannot reveal the article.
const information = document.getElementById("creator-information");
const editor = document.getElementById("native-editor");
if (information && editor) {
  let reading = false;
  const setReading = (value: boolean) => {
    reading = value;
    document.documentElement.classList.toggle(
      "native-information-reading",
      value,
    );
    editor.inert = value;
    if (value) {
      information.focus({ preventScroll: true });
      information.scrollIntoView();
    } else {
      window.scrollTo(0, 0);
      editor
        .querySelector<HTMLElement>("#native-overlay")
        ?.focus({ preventScroll: true });
    }
  };
  document
    .querySelectorAll(".creator-information-link")
    .forEach((link) => link.addEventListener("click", () => setReading(true)));
  information
    .querySelector("[data-return-to-editor]")
    ?.addEventListener("click", () => setReading(false));
  window.addEventListener("hashchange", () =>
    setReading(location.hash === "#creator-information"),
  );
  if (location.hash === "#creator-information") setReading(true);
  window.addEventListener(
    "scroll",
    () => {
      if (!reading && window.scrollY !== 0) window.scrollTo(0, 0);
    },
    { passive: true },
  );
  for (const type of ["keydown", "copy", "cut", "paste", "dragover", "drop"]) {
    window.addEventListener(
      type,
      (event) => {
        if (reading || information.contains(event.target as Node)) {
          if (type === "drop" || type === "dragover") event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true,
    );
  }
}
